/* @flow strict */

import * as React from 'react';
import Loader from '/client/src/components/Loader';
import PieBreakdown from './pieBreakdown';

type PropsType = {
  eventId: number | string
};

const EventPageDetailStatsAcBreakdown = ({ eventId }: PropsType): React.Element<'div'> => {
  const [data, setAttendance] = React.useState(null);

  const handleLoaded = React.useCallback(async (error: Error, response: any) => {
    const _data = [
      {
        id: 1,
        name: 'First time guest',
        value: null
      },
      {
        id: 2,
        name: 'Attended 2 events',
        value: null
      },
      {
        id: 3,
        name: 'Attended 3 events',
        value: null
      },
      {
        id: 4,
        name: 'Attended 4 events',
        value: null
      }
    ];

    if (!error) {
      try {
        const responseData = _.get(response, 'data.result', []);

        responseData.map((item: any) => {
          const hasCount = _data.find((el: any): void => el.id === item.attendance_event_count);

          if (hasCount) hasCount.value = item.count;
        });

        const res = _data.filter(i => i.value !== null);

        setAttendance(!!res.length ? res : false);
      } catch (e) {
        console.log(e);
      }
    }
  }, []);

  return (
    <Loader
      url={`/api/v1/1/statistics/events/${eventId}/attendance_count`}
      onLoaded={handleLoaded}
    >
      <div className="panel panel-default panel-chart">
        <div className="panel-heading">
          Attendance Breakdown
        </div>

        {!!data ?
          <PieBreakdown data={data} type={'Attendance'}/>
        :
           <div className="panel-body">
             <div className="no-data">
               <div className="img" />
               <div className="text">No Data</div>
             </div>
           </div>
        }
      </div>
    </Loader>
  );
};

export default EventPageDetailStatsAcBreakdown;
